import { Component, OnInit, ViewEncapsulation, Input, NgZone, Output, EventEmitter, forwardRef, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs/Rx';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/catch';
import * as codeconvertArray from './iso3-codes.json';
const H = window['H'];
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ParameterService } from '../../utils/services/parameter.service';

@Component({
  selector: 'app-google-autocomplete-input',
  templateUrl: './google-autocomplete-input.component.html',
  styleUrls: ['./google-autocomplete-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GoogleAutocompleteInputComponent),
      multi: true
    }
  ]
})
export class GoogleAutocompleteInputComponent implements OnInit, ControlValueAccessor {

  search: FormControl;
  selectedCity = null;
  isPanelVisible = false;
  isDataLoaded = false;

  @Input() validateCityFromParameter = true;
  @Input()
  gMapElement;

  @Output()
  onCitySelected: EventEmitter<any> = new EventEmitter();

  validatedBiziCitiesPositions = [];
  validatedBiziCities = [];
  parameterValidationSubscription: Subscription = null;
  predictionRequestSubscription: Subscription = null;
  public propagateChange = (_: any) => {
  };

  @HostListener("window:click", ["$event"])
  clickHandler(event) {
    if (!(this.elementRef.nativeElement.contains(event.target))) {
      this.isPanelVisible = false;
    }
  }

  constructor(private parameter: ParameterService, private elementRef: ElementRef,
    private cd: ChangeDetectorRef) { }

  geocoder;
  ngOnInit() {
    const platform = new H.service.Platform({
      app_id: 'DvkMLJUCGTNvYUfJKvjI',
      app_code: 'WCu2vYFedd98VySNf6gWWQ',
      useCIT: false,
      useHTTPS: true
    });
    const defaultLayers = platform.createDefaultLayers();
    this.geocoder = platform.getGeocodingService();
    this.search = new FormControl();
    let searchH = new H.places.Suggest(platform.getPlacesService())
    this.search.valueChanges.debounceTime(400).distinctUntilChanged().subscribe(val => {
      if (!val || val.length < 3 || (this.selectedCity && (this.selectedCity.inputPlace == val || this.selectedCity.desc == val))) {
        return;
      } else {

        this.isPanelVisible = true;
        this.isDataLoaded = false;

        this.validatedBiziCities = [];
        this.validatedBiziCitiesPositions = [];

        if (this.predictionRequestSubscription) {
          this.predictionRequestSubscription.unsubscribe();
          this.validatedBiziCitiesPositions = [];
        }
        let params = {
          q: val,
          at: '0,0'
        };

      // console.log('Cll Here AutoComplete', params)

        this.parameter.autoSuggest(params).subscribe(res => {
        // console.log('Cll Here AutoComplete response', res)
          let needValidateCities = [];
          let placePredictionList = [];
          let len = res['results'].length;
          let cnt = 0;
          let count = 0;
          let reverseSuggestCalls = [];
          let autoSuggestResp = res['results'];
          res['results'].forEach((item1, index) => {
            if (item1.href && item1.resultType !== 'query') {
              cnt += 1;
              let reverseGeocodingParameters = {
                prox: item1.position ? item1.position.toString() : '0,0',
                mode: 'retrieveAddresses',
                maxresults: 1
              };
              reverseSuggestCalls.push(
                this.parameter.reverseSuggest(item1.href).map(e => {
                // console.log(e);
                  return Observable.of([e]);
                  /* let item = e;
                  let data;
                  count += 1;
                  item['searchField'] = item1.title;
                  item['longTitle'] = item1.highlightedTitle.split('<br/>').toString()
                  item['title'] = " <span>" + item1.highlightedTitle + '</span>' + " <span class='inner'>( " + (item1.highlightedVicinity ? item1.highlightedVicinity.split('<br/>').toString() : '') + ' )</span>';
                  item['rawTitle'] = (item1.highlightedTitle + ' ' + (item1.highlightedVicinity ? item1.highlightedVicinity.split('<br/>').toString() : '')).replace(/<\/{0,1}[a-z]+>/gi, "");
                  if (item['location'] && item['location'].address.city) {
                    data = {
                      name: item['location'].address.city,
                      countryCode: (<any>codeconvertArray).filter(p => p['alpha-3'] === item['location'].address.countryCode)[0]['alpha-2'],
                      countryName: item['location'].address.country
                    }
                    placePredictionList.push(item);
                    needValidateCities.push(data);
                  }
                  if (count === cnt) {
                    this.validateAutoCompleteCities(needValidateCities, placePredictionList);
                  } */
                }).catch((err) => { return Observable.of([]) }));
            }
          })
          Observable.forkJoin(reverseSuggestCalls).subscribe(resp => {
            resp.forEach((e, i) => {
              let item = e['value'][0];
              let data;
              count += 1;
              item['searchField'] = autoSuggestResp[i].title;
              item['longTitle'] = autoSuggestResp[i].highlightedTitle.split('<br/>').toString()
              item['title'] = " <span>" + autoSuggestResp[i].highlightedTitle + '</span>' + " <span class='inner'>( " + (autoSuggestResp[i].highlightedVicinity ? autoSuggestResp[i].highlightedVicinity.split('<br/>').toString() : '') + ' )</span>';
              item['rawTitle'] = (autoSuggestResp[i].highlightedTitle + ' ' + (autoSuggestResp[i].highlightedVicinity ? autoSuggestResp[i].highlightedVicinity.split('<br/>').toString() : '')).replace(/<\/{0,1}[a-z]+>/gi, "");
              if (item['location'] && item['location'].address.city) {
                if(item.categories && item.categories[0].id == 'city-town-village' || item.categories[0].id == 'hotel'){
                  if(item.categories[0].id == 'city-town-village'){
                    let countryCode = (<any>codeconvertArray).filter(p => p['alpha-3'] === item['location'].address.countryCode);
                    data = {
                      name: item.name,
                      countryCode: (countryCode && countryCode[0]) ?  countryCode[0]['alpha-2'] : null,
                      countryName: item['location'].address.country
                    }
                  }else{
                    let countryCode = (<any>codeconvertArray).filter(p => p['alpha-3'] === item['location'].address.countryCode);
                    data = {
                      name: item.location.address.city,
                      countryCode: (countryCode && countryCode[0]) ? countryCode[0]['alpha-2'] : null,
                      countryName: item['location'].address.country
                    }
                  }
                  
                }else{
                  if(item.location.address.county){
                    let countryCode = (<any>codeconvertArray).filter(p => p['alpha-3'] === item['location'].address.countryCode);
                    data = {
                      name: item['location'].address.county,
                      countryCode: (countryCode && countryCode[0]) ? countryCode[0]['alpha-2'] : null,
                      countryName: item['location'].address.country
                    }
                  }else{
                    let countryCode = (<any>codeconvertArray).filter(p => p['alpha-3'] === item['location'].address.countryCode);
                    data = {
                      name: item['location'].address.city,
                      countryCode: (countryCode && countryCode[0]) ? countryCode[0]['alpha-2'] : null,
                      countryName: item['location'].address.country
                    }
                  }
                }
                placePredictionList.push(item);
                needValidateCities.push(data);
              }
            })
            this.validateAutoCompleteCities(needValidateCities, placePredictionList);
          }, err => {
          // console.log(err)
          })
        })

      }
    })
  }

  validateAutoCompleteCities(autoCompleteCityList, placePredictionList) {
    let parameterReqData = autoCompleteCityList;
    if (this.parameterValidationSubscription) {
      this.parameterValidationSubscription.unsubscribe();
      this.validatedBiziCities = [];
    }
    this.parameterValidationSubscription = this.parameter.getHotelCities({ data: parameterReqData }).subscribe(paramRes => {
      let validatedCities = paramRes.data;
      /* if (this.validateCityFromParameter) { */

        autoCompleteCityList.forEach((item, index) => {
          if (this.validateCityFromParameter) {
            if (validatedCities[index].result) {
              this.validatedBiziCities.push({
                cityId: validatedCities[index].result,
                desc: placePredictionList[index].title,
                rawDesc: placePredictionList[index].rawTitle,
                longDesc: placePredictionList[index].longTitle,
                inputPlace: placePredictionList[index].searchField,
                cityName: autoCompleteCityList[index].name,
                countryCode: autoCompleteCityList[index].countryCode,
                countryName: autoCompleteCityList[index].countryName,
                position: { lat: placePredictionList[index]['location'].position[0], lng: placePredictionList[index]['location'].position[1] }
              })
            }
          } else {
            this.validatedBiziCities.push({
              cityId: validatedCities[index].result,
              desc: placePredictionList[index].title,
              rawDesc: placePredictionList[index].rawTitle,
              longDesc: placePredictionList[index].longTitle,
              inputPlacex: placePredictionList[index].searchField,
              cityName: autoCompleteCityList[index].name,
              countryCode: autoCompleteCityList[index].countryCode,
              countryName: autoCompleteCityList[index].countryName,
              position: { lat: placePredictionList[index]['location'].position[0], lng: placePredictionList[index]['location'].position[1] }
            })
          }
        });
      /* } else {
        autoCompleteCityList.forEach((validateElement, index) => {
          this.validatedBiziCities.push({
            desc: placePredictionList[index].title,
            rawDesc: placePredictionList[index].rawTitle,
            longDesc: placePredictionList[index].longTitle,
            inputPlace: placePredictionList[index].searchField,
            cityName: autoCompleteCityList[index].name,
            cityId: validatedCities[index].result,
            countryCode: autoCompleteCityList[index].countryCode,
            countryName: autoCompleteCityList[index].countryName,
            position: { lat: placePredictionList[index]['location'].position[0], lng: placePredictionList[index]['location'].position[1] }
          })
        });
      } */

      this.isDataLoaded = true;
      this.cd.detectChanges();
    });
  }

  writeValue(obj: any): void {
    this.selectedCity = {};
    this.selectedCity["desc"] = obj;
    this.search.patchValue(obj);
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;

  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }


  onListItemClicked(index) {
    this.selectedCity = this.validatedBiziCities[index];
    this.search.patchValue(this.validatedBiziCities[index].inputPlace);
    this.isPanelVisible = false;
    this.onCitySelected.emit({ item: this.selectedCity });
    this.propagateChange({ item: this.selectedCity });
  }


}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/google-autocomplete-input/google-autocomplete-input.component.ts